(function () {
  let bundleCartRequestInFlight = false;

  function qs(sel, root) {
    return (root || document).querySelector(sel);
  }

  function qsa(sel, root) {
    return Array.from((root || document).querySelectorAll(sel));
  }

  function showError() {
    const el = qs("#grid-bundle-error") || qs(".dropdown-bundle-error");
    if (el) el.classList.remove("hidden");
  }

  function hideError() {
    const el = qs("#grid-bundle-error") || qs(".dropdown-bundle-error");
    if (el) el.classList.add("hidden");
  }

  function formatNis(cents) {
    const value = (Number(cents) / 100).toFixed(2);
    const parts = value.split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return `₪${parts.join(".")}`;
  }

  function priceFromItemNode(node) {
    if (!node) return 0;
    return Number(node.getAttribute("data-product-bundle-price") || 0);
  }

  function clubPriceFromItemNode(node) {
    if (!node) return 0;
    const attr = node.getAttribute("data-product-bundle-club-price");
    if (!attr) return 0;
    return Number(attr || 0);
  }

  function setItemNodePrices(node, price, clubPrice) {
    if (!node) return;

    node.setAttribute("data-product-bundle-price", String(price || 0));

    if (clubPrice && clubPrice > 0) {
      node.setAttribute("data-product-bundle-club-price", String(clubPrice));
    } else {
      node.removeAttribute("data-product-bundle-club-price");
    }

    const card = node.closest(".grid-item");
    const currentEl = qs(".grid-product__price--current", card);
    const clubEl = qs(".boa-club-price-price", card);
    const compareEl = qs(".grid-product__price--original", card);
    const clubWrap = qs(".boa-club-price-wrap", card);

    if (currentEl) currentEl.textContent = formatNis(price || 0);

    if (clubEl && clubPrice && clubPrice > 0) {
      clubEl.textContent = formatNis(clubPrice);
    }

    if (clubWrap) {
      clubWrap.style.display = clubPrice && clubPrice > 0 ? "" : "none";
    }

    if (compareEl) {
      const compareRaw = Number(compareEl.getAttribute("data-compare-price") || 0);
      compareEl.textContent = compareRaw > (price || 0) ? formatNis(compareRaw) : "";
    }
  }

  function setMainBundleImage(imgEl, url) {
    if (!imgEl || !url) return;

    imgEl.src = url;
    imgEl.setAttribute("src", url);
    imgEl.removeAttribute("srcset");
    imgEl.removeAttribute("sizes");

    if (imgEl.dataset && imgEl.dataset.src) {
      imgEl.dataset.src = url;
    }
  }

  function getBundlePricingData() {
    const el = qs("#bundle-pricing-data");
    if (!el) {
      return { title: "", basePrice: 0, baseClubPrice: 0 };
    }

    const baseClubAttr = el.getAttribute("data-bundle-base-club-price");

    return {
      title: el.getAttribute("data-bundle-title") || "",
      basePrice: Number(el.getAttribute("data-bundle-base-price") || 0),
      baseClubPrice: baseClubAttr ? Number(baseClubAttr) : 0
    };
  }

  function getBundleParentVariantId() {
    const input = qs("#bundle-parent-variant");
    if (!input) return null;
    const id = String(input.value || "").trim();
    return id ? Number(id) : null;
  }

  function getBundleRequiredInputs() {
    return qsa(".bundle-main-items .bundle-required-variant");
  }

  function getRequiredChildVariantIds() {
    return getBundleRequiredInputs()
      .map((input) => String(input.value || "").trim())
      .filter(Boolean)
      .map(Number);
  }

  function getBundleId() {
    const parentVariantId = getBundleParentVariantId();
    const childVariantIds = getRequiredChildVariantIds();
    if (!parentVariantId || !childVariantIds.length) return "";
    return [parentVariantId, ...childVariantIds].join(":");
  }

  function getSelectedMattressButton() {
    return qs(".bundle-addon-toggle.is-selected");
  }

  function getSelectedMattressData() {
    const btn = getSelectedMattressButton();
    if (!btn) return null;
    return getMattressDataFromButton(btn);
  }

  function getMattressDataFromButton(btn) {
    if (!btn) return null;

    const id = btn.getAttribute("data-bundle-variant-id");
    if (!id) return null;

    const card = btn.closest(".grid-item");
    const node = card ? qs(".product-grid-item", card) : null;
    const titleEl = card ? qs(".grid-product__title", card) : null;

    return {
      id: Number(id),
      quantity: 1,
      title: titleEl ? titleEl.textContent.trim() : "",
      price: priceFromItemNode(node),
      clubPrice: clubPriceFromItemNode(node)
    };
  }

  async function addItems(items) {
    const res = await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      body: JSON.stringify({ items })
    });

    if (!res.ok) {
      const txt = await res.text();
      throw new Error(txt || "Cart add failed");
    }

    return res.json();
  }

  async function getCart() {
    const res = await fetch("/cart.js", {
      method: "GET",
      headers: { Accept: "application/json" }
    });

    if (!res.ok) throw new Error("Failed to load cart");
    return res.json();
  }

  function anyRequiredSelectionOutOfStock() {
    return qsa(".bundle-main-items .swatch-color-boa.current-product-color.product-sold-out").length > 0;
  }

  function syncMainAddToCartState() {
    const isOos = anyRequiredSelectionOutOfStock();

    qsa("[data-bundle-add-to-cart], .btn-add-to-registry--grid-bundle").forEach((btn) => {
      if (isOos) {
        btn.disabled = true;
        btn.classList.add("is-disabled", "is-out-of-stock");
        if (btn.hasAttribute("data-bundle-add-to-cart")) {
          btn.textContent = "אזל מהמלאי";
        }
      } else {
        btn.disabled = false;
        btn.classList.remove("is-disabled", "is-out-of-stock");
        if (btn.hasAttribute("data-bundle-add-to-cart")) {
          btn.textContent = "הוסף לסל";
        }
      }
    });
  }

  function updateTotalPrice() {
    const pricing = getBundlePricingData();

    let regularTotal = pricing.basePrice;
    const hasClubPrice = pricing.baseClubPrice > 0;
    let clubTotal = hasClubPrice ? pricing.baseClubPrice : 0;

    const mattress = getSelectedMattressData();

    if (mattress) {
      regularTotal += mattress.price;

      if (hasClubPrice) {
        clubTotal += mattress.clubPrice && mattress.clubPrice > 0 ? mattress.clubPrice : mattress.price;
      }
    }

    qsa(".bundle-price").forEach((el) => {
      el.textContent = formatNis(regularTotal);
    });

    if (hasClubPrice) {
      qsa(".bundle-summary-club, .bundle-footer .boa-club-price-wrap").forEach((el) => {
        el.style.display = "";
      });

      qsa(".bundle-summary-club-value, .bundle-footer .boa-club-price-price").forEach((el) => {
        el.textContent = formatNis(clubTotal);
      });
    } else {
      qsa(".bundle-summary-club, .bundle-footer .boa-club-price-wrap").forEach((el) => {
        el.style.display = "none";
      });
    }

    syncMainAddToCartState();
  }

  function buildBundleChildItems() {
    const childVariantIds = getRequiredChildVariantIds();
    const pricing = getBundlePricingData();
    const bundleId = getBundleId();

    if (!bundleId || !childVariantIds.length) return [];

    return childVariantIds.map((variantId) => ({
      id: variantId,
      quantity: 1,
      properties: {
        _bundleId: bundleId,
        _bundle_title: pricing.title || "",
        _bundle_builder: "grid_bundle"
      }
    }));
  }

  function buildMattressItemFromData(mattressData) {
    if (!mattressData || !mattressData.id) return null;
    return { id: mattressData.id, quantity: 1 };
  }

  function getItemBundleId(item) {
    const props = item && item.properties ? item.properties : {};
    return props._bundleId || "";
  }

  function cartHasCurrentBundle(cart) {
    if (!cart || !Array.isArray(cart.items)) return false;

    const bundleId = getBundleId();
    const pricing = getBundlePricingData();
    const bundleTitle = pricing.title || "";

    if (bundleId) {
      const hasBundleById = cart.items.some((item) => getItemBundleId(item) === bundleId);
      if (hasBundleById) return true;
    }

    return cart.items.some((item) => {
      const props = item.properties || {};
      return props._bundle_builder === "grid_bundle" && (!bundleTitle || props._bundle_title === bundleTitle);
    });
  }

  function cartHasVariant(cart, variantId) {
    if (!cart || !Array.isArray(cart.items) || !variantId) return false;
    return cart.items.some((item) => Number(item.variant_id) === Number(variantId));
  }

  function openCartDrawer() {
    window.scrollTo({ top: 0, behavior: "smooth" });

    setTimeout(() => {
      document.dispatchEvent(new CustomEvent("cart:build"));
      document.dispatchEvent(new CustomEvent("cart:open"));
    }, 250);
  }

  function markMattressAdded(btn, text) {
    if (!btn) return;
    btn.classList.add("is-added");
    btn.classList.remove("is-selected");
    btn.textContent = text || "נוסף לסל";
    btn.closest(".grid-item")?.classList.remove("bundle-addon-selected");
  }

  function parseGallery(galleryRaw) {
    if (!galleryRaw) return [];
    try {
      const parsed = JSON.parse(galleryRaw);
      return Array.isArray(parsed) ? parsed : [];
    } catch (err) {
      console.error("Failed to parse gallery JSON", err);
      return [];
    }
  }

  function rebuildBundleThumbs(card, galleryRaw, productTitle) {
    const thumbsWrap = qs("[data-bundle-thumbs]", card);
    const mainImg = qs("[data-bundle-main-img]", card);
    if (!thumbsWrap) return;

    const images = parseGallery(galleryRaw);
    if (!images.length) return;

    thumbsWrap.innerHTML = images
      .map((imgObj, index) => {
        const full = imgObj.full || "";
        const thumb = imgObj.thumb || full;
        const isActive = index === 0 ? " is-active" : "";
        const safeTitle = (productTitle || "").replace(/"/g, "&quot;");
        return `
          <button
            type="button"
            class="bundle-tile-thumb${isActive}"
            data-bundle-thumb
            data-full-src="${full}"
            aria-label="${safeTitle} thumbnail ${index + 1}"
          >
            <img src="${thumb}" alt="" loading="lazy" width="44" height="44">
          </button>
        `;
      })
      .join("");

    const firstImage = images[0] && images[0].full ? images[0].full : "";
    if (mainImg && firstImage) {
      setMainBundleImage(mainImg, firstImage);
    }
  }

  function applyColorProductToCard(card, swatch) {
    if (!card || !swatch) return;

    const variantId = swatch.getAttribute("data-variant-id") || swatch.getAttribute("data-key");
    const available = swatch.getAttribute("data-product-available") === "true";
    const price = Number(swatch.getAttribute("data-product-price") || 0);
    const comparePrice = Number(swatch.getAttribute("data-product-compare-price") || 0);
    const clubPriceAttr = swatch.getAttribute("data-product-club-price");
    const clubPrice = clubPriceAttr ? Number(clubPriceAttr) : 0;
    const image = swatch.getAttribute("data-product-image") || "";
    const gallery = swatch.getAttribute("data-product-gallery") || "";
    const productTitle = swatch.getAttribute("data-product-title") || "";
    const productColor = swatch.getAttribute("data-product-color") || "";

    const itemNode = qs(".product-grid-item", card);
    const mainImg = qs("[data-bundle-main-img]", card);
    const stockStatus = qs("[data-bundle-stock-status]", card);
    const colorLabelEl = qs("[data-bundle-color-label]", card);
    const titleEl = qs(".grid-product__title", card);
    const addonBtn = qs(".bundle-addon-toggle", card);
    const requiredInput = qs(".bundle-required-variant", card);

    if (itemNode && variantId) {
      itemNode.setAttribute("data-selected-variant-id", variantId);
      setItemNodePrices(itemNode, price, clubPrice);
    }

    if (requiredInput && variantId) {
      requiredInput.value = variantId;
    }

    rebuildBundleThumbs(card, gallery, productTitle);

    if (mainImg && image && !gallery) {
      setMainBundleImage(mainImg, image);
    }

    if (titleEl && productTitle) {
      titleEl.textContent = productTitle;
    }

    if (colorLabelEl) {
      colorLabelEl.textContent = productColor;
    }

    if (stockStatus) {
      stockStatus.textContent = available ? "" : "אזל מהמלאי";
    }

    const currentPriceEl = qs(".grid-product__price--current", card);
    const clubPriceEl = qs(".boa-club-price-price", card);
    const clubWrap = qs(".boa-club-price-wrap", card);
    const comparePriceEl = qs(".grid-product__price--original", card);

    if (currentPriceEl) {
      currentPriceEl.textContent = formatNis(price);
    }

    if (clubPriceEl && clubPrice > 0) {
      clubPriceEl.textContent = formatNis(clubPrice);
    }

    if (clubWrap) {
      clubWrap.style.display = clubPrice > 0 ? "" : "none";
    }

    if (comparePriceEl) {
      comparePriceEl.textContent = comparePrice > price ? formatNis(comparePrice) : "";
      comparePriceEl.setAttribute("data-compare-price", String(comparePrice || 0));
    }

    if (addonBtn && variantId) {
      addonBtn.setAttribute("data-bundle-variant-id", variantId);

      if (available) {
        addonBtn.disabled = false;
        addonBtn.classList.remove("is-disabled");
        if (!addonBtn.classList.contains("is-added") && !addonBtn.classList.contains("is-selected")) {
          addonBtn.textContent = "הוסף לסל";
        }
      } else {
        addonBtn.disabled = true;
        addonBtn.classList.add("is-disabled");
        addonBtn.classList.remove("is-selected");
        addonBtn.classList.remove("is-added");
        addonBtn.textContent = "אזל מהמלאי";
        card.classList.remove("bundle-addon-selected");
      }
    }

    updateTotalPrice();
  }

  async function refreshMattressButtonsState() {
    try {
      const cart = await getCart();
      const bundleInCart = cartHasCurrentBundle(cart);

      qsa(".bundle-addon-toggle").forEach((btn) => {
        const mattress = getMattressDataFromButton(btn);
        const inCart = mattress ? cartHasVariant(cart, mattress.id) : false;

        btn.dataset.directAdd = bundleInCart ? "true" : "false";

        if (btn.classList.contains("is-disabled")) return;

        btn.disabled = false;

        if (bundleInCart) {
          btn.classList.remove("is-selected");
          btn.closest(".grid-item")?.classList.remove("bundle-addon-selected");

          if (inCart) {
            btn.classList.add("is-added");
            btn.textContent = "כבר בסל";
          } else {
            btn.classList.remove("is-added");
            btn.textContent = "הוסף לסל";
          }
        } else {
          if (btn.classList.contains("is-selected")) {
            btn.textContent = "נבחר";
            btn.closest(".grid-item")?.classList.add("bundle-addon-selected");
          } else {
            btn.classList.remove("is-added");
            btn.textContent = "הוסף לסל";
            btn.closest(".grid-item")?.classList.remove("bundle-addon-selected");
          }
        }
      });

      updateTotalPrice();
    } catch (err) {
      console.error(err);
    }
  }

  function setupMattressButtons() {
    document.addEventListener("click", async (e) => {
      const btn = e.target.closest(".bundle-addon-toggle");
      if (!btn) return;
      if (btn.classList.contains("is-disabled")) return;

      const directAddMode = btn.dataset.directAdd === "true";

      if (!directAddMode) {
        const wasSelected = btn.classList.contains("is-selected");

        qsa(".bundle-addon-toggle.is-selected").forEach((b) => {
          b.classList.remove("is-selected");
          b.classList.remove("is-added");
          b.textContent = "הוסף לסל";
          b.closest(".grid-item")?.classList.remove("bundle-addon-selected");
        });

        if (!wasSelected) {
          btn.classList.add("is-selected");
          btn.textContent = "נבחר";
          btn.closest(".grid-item")?.classList.add("bundle-addon-selected");
        } else {
          btn.classList.remove("is-selected");
          btn.textContent = "הוסף לסל";
          btn.closest(".grid-item")?.classList.remove("bundle-addon-selected");
        }

        updateTotalPrice();
        return;
      }

      e.preventDefault();
      e.stopPropagation();

      if (bundleCartRequestInFlight) return;

      const mattressData = getMattressDataFromButton(btn);
      if (!mattressData) return;

      bundleCartRequestInFlight = true;

      try {
        btn.disabled = true;

        const cart = await getCart();
        if (cartHasVariant(cart, mattressData.id)) {
          btn.textContent = "כבר בסל";
          btn.classList.add("is-added");
          return;
        }

        await addItems([buildMattressItemFromData(mattressData)]);
        markMattressAdded(btn, "נוסף לסל");
        openCartDrawer();
      } catch (err) {
        console.error(err);
        showError();
      } finally {
        bundleCartRequestInFlight = false;
        btn.disabled = false;
        refreshMattressButtonsState();
      }
    });
  }

  function setupAddToCartButtons() {
    qsa("[data-bundle-add-to-cart]").forEach((btn) => {
      btn.addEventListener("click", async () => {
        hideError();

        if (bundleCartRequestInFlight) return;
        if (anyRequiredSelectionOutOfStock()) return;

        const bundleItems = buildBundleChildItems();
        if (!bundleItems.length) {
          showError();
          return;
        }

        const selectedMattress = getSelectedMattressData();
        const mattressItem = buildMattressItemFromData(selectedMattress);

        bundleCartRequestInFlight = true;

        try {
          btn.disabled = true;

          const cart = await getCart();
          const bundleInCart = cartHasCurrentBundle(cart);

          let items = [];

          if (!bundleInCart) {
            items = bundleItems.slice();

            if (mattressItem && !cartHasVariant(cart, mattressItem.id)) {
              items.push(mattressItem);
            }
          } else if (mattressItem && !cartHasVariant(cart, mattressItem.id)) {
            items = [mattressItem];
          }

          if (!items.length) {
            await refreshMattressButtonsState();
            return;
          }

          await addItems(items);
          openCartDrawer();
        } catch (err) {
          console.error(err);
          showError();
        } finally {
          bundleCartRequestInFlight = false;
          btn.disabled = false;
          refreshMattressButtonsState();
        }
      });
    });
  }

  function setupBundleColorSwatches() {
    document.addEventListener("click", (e) => {
      const swatch = e.target.closest(".swatch-color-boa");
      if (!swatch) return;

      e.preventDefault();
      e.stopPropagation();

      const card = swatch.closest(".grid-item");
      if (!card) return;

      qsa(".swatch-color-boa.current-product-color", card).forEach((btn) => {
        btn.classList.remove("current-product-color");
        btn.classList.remove("is-active");
        btn.removeAttribute("aria-pressed");
        btn.blur();
      });

      qsa(".swatch-color-boa", card).forEach((btn) => {
        btn.classList.remove("is-active");
        btn.removeAttribute("aria-pressed");
      });

      swatch.classList.add("current-product-color");
      swatch.classList.add("is-active");
      swatch.setAttribute("aria-pressed", "true");
      swatch.blur();

      applyColorProductToCard(card, swatch);
    });
  }

  document.addEventListener("click", function (e) {
    const thumb = e.target.closest("[data-bundle-thumb]");
    if (!thumb) return;

    e.preventDefault();
    e.stopPropagation();

    const card = thumb.closest(".grid-item, .bundle-card, .product-grid-item");
    if (!card) return;

    const mainImg = card.querySelector("[data-bundle-main-img]");
    const fullSrc = thumb.getAttribute("data-full-src");
    if (!mainImg || !fullSrc) return;

    setMainBundleImage(mainImg, fullSrc);

    card.querySelectorAll("[data-bundle-thumb].is-active").forEach((x) => x.classList.remove("is-active"));
    thumb.classList.add("is-active");
  });

  document.addEventListener("keydown", function (e) {
    const thumb = e.target.closest("[data-bundle-thumb]");
    if (!thumb) return;
    if (e.key !== "Enter" && e.key !== " ") return;

    e.preventDefault();
    e.stopPropagation();
    thumb.click();
  });

  document.addEventListener("DOMContentLoaded", () => {
    setupBundleColorSwatches();
    setupMattressButtons();
    setupAddToCartButtons();
    updateTotalPrice();
    refreshMattressButtonsState();
    syncMainAddToCartState();
  });

  document.addEventListener("cart:build", () => {
    refreshMattressButtonsState();
    syncMainAddToCartState();
  });
})();